import assets from '../../assets'
import { Pagination } from "../pagination"
import { STUNDET_ACTIVITY_DETAILS, getStudentActivityDetails } from "../../utils/constant"
import { useHandler } from './handler'

export const AspirantManagement = () => {
  const {
    fileInputRef,
    currentPage,
    studentSearchDetails,
    data,
    pageSize,
    setData,
    onDelete,
    onChangeValue,
    setCurrentPage,
    onChangeFile,
    getStudentDetails,
    removeMultiple,
    handleCheckboxChange,
    clearSelectedEmails,
    activateUsers,
    deActivateUsers,
    getSelectedEmails,
    studentDetsils,
      loading
  } = useHandler()

  const { search } = data
  const emails = getSelectedEmails()

const filteredData = studentSearchDetails?.filter((item) =>
  item?.Name?.toLowerCase()?.includes(search?.toLowerCase())
);

const currentData = search
  ? filteredData
  : filteredData?.slice(
      (currentPage - 1) * pageSize,
      currentPage * pageSize
    );

const STUNDET_ACTIVITY_DETAILS = getStudentActivityDetails(
  studentDetsils,
  assets
);

  const renderActivityDetails = (item, index) => {
    const { icon, title, noOfStundets } = item || {}
    return (
      <section className="student_activity_container" key={index}>
        <section className="activity_img_wrapper">
          <img src={icon} alt="activity icon" />
        </section>
        <section className="total_student_wrapper">
          <h5>{title}</h5>
          <h4>{noOfStundets}</h4>
        </section>
      </section>
    )
  }

  return (
    <section className="student_manage_page_wrapper">
      <header className="student_manage_header">
        <h4>Aspirant Management</h4>
        <section className="notify_wrapper">
          <img src={assets.ic_notify_bell} alt="notification" />
        </section>
      </header>

      <section className="student_manage_content_wrapper">
        <section className="student_manage_content_main_wrapper">
          <section className="student_activity_wrapper">
            <section className="student_activity_content_wrapper">
              {STUNDET_ACTIVITY_DETAILS?.map(renderActivityDetails)}
            </section>
          </section>
          
          <section className="refresh_import_container">
            <button 
              className="refresh_btn" 
              onClick={() => {
                getStudentDetails()
                setData((prev) => ({ ...prev, search: "" }))
              }}
            >
              <img src={assets.ic_refetch} alt="refresh" />
              <h5>Refresh</h5>
            </button>
            <button className="import_btn" onClick={() => fileInputRef.current.click()}>
              <img src={assets.ic_download_arrow} alt='import' />
              <h5>Import Users</h5>
              <input 
                type="file" 
                name='selectfile' 
                ref={fileInputRef} 
                accept=".xlsx,.xls" 
                style={{ display: "none" }} 
                onChange={onChangeFile} 
              />
            </button>
          </section>
        </section>

        {emails.length > 0 && (
          <section className="student_manage_active_deactive_wrapper">
            <h4>{`${emails.length} student${emails.length > 1 ? 's' : ''} selected`}</h4>
            <section className="student_manage_active_deactive_container">
              <section className="student_manage_active_wrapper" onClick={activateUsers}>
                <img src={assets.ic_tick_white} alt="activate" />
                <h4>Activate Selected</h4>
              </section>
              <section className="student_manage_deactive_wrapper" onClick={deActivateUsers}>
                <img src={assets.ic_close_white} alt="deactivate" />
                <h4>Deactivate Selected</h4>
              </section>
              <img 
                src={assets.ic_close} 
                alt="clear selection" 
                className="clear_selection_icon"
                onClick={clearSelectedEmails} 
                style={{ cursor: 'pointer', opacity: 0.5 }}
              />
            </section>
          </section>
        )}

        <section className="student_manage_table_search_continer">
          <section className="student_manage_search_wrapper">
            <img src={assets.ic_search} alt="search" />
            <input 
              placeholder="Search aspirants by name or ID..." 
              name="search" 
              value={search} 
              onChange={onChangeValue} 
            />
          </section>
          <section className="student_manage_school_wrapper">
            {emails.length > 0 && (
              <button className="multiple_btn" onClick={removeMultiple}>
                Delete Selected
              </button>
            )}
          </section>
        </section>

        <section className="table_container">
            {loading && (
                    <div className="table_loader_overlay">
                        <div className="spinner"></div>
                    </div>
                )}
          <table className="student_table">
            <thead>
              <tr>
                <th style={{ width: '40px' }}></th>
                <th>Student</th>
                <th>DOB</th>
                <th>Graduation</th>
                <th>ExamType</th>
                <th style={{ textAlign: 'center' }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {currentData && currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <input 
                        type="checkbox" 
                        checked={!!data.selectedEmails[item?.Mail]} 
                        onChange={() => handleCheckboxChange(item?.Mail)} 
                      />
                    </td>
                    <td>
                      <section className="student_profile_cell">
<section className="student_image">
  {item?.Name?.charAt(0)?.toUpperCase()}
</section>
                        <section>
                          <h4 className="student_name">{item?.Name}</h4>
                          <p className="student_email">{item?.Mail}</p>
                        </section>
                      </section>
                    </td>
                    <td>{item?.DOB || '-'}</td>
                    <td>{item?.Graduation || '-'}</td>
                    <td>{item?.Exam_Type || '-'}</td>
                    <td className="action_icons" style={{ justifyContent: 'center' }}>
                      <img 
                        src={assets.ic_delete_record} 
                        alt="delete" 
                        className='delete' 
                        onClick={onDelete.bind(null, item?.Mail)} 
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" style={{ textAlign: 'center', padding: '40px', color: '#94a3b8' }}>
                    No students found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          
          {studentSearchDetails?.length > pageSize && (
            <Pagination
              totalResults={filteredData?.length}
              pageSize={pageSize}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          )}
        </section>
      </section>
    </section>
  )
}
